import React from "react";
import { Link } from "react-router-dom";
import { Store } from "lucide-react";

export default function LogoMarquee({ businesses = [] }) {
  if (!businesses || businesses.length === 0) {
    return (
      <div className="gp-hero-gradient border-t border-white/5">
        <p className="text-center text-white/60 text-sm py-10">Businesses on the platform will appear here.</p>
      </div>
    );
  }
  // duplicate for a continuous marquee
  const row = businesses.length < 6
    ? [...businesses, ...businesses, ...businesses, ...businesses]
    : [...businesses, ...businesses];

  return (
    <div className="gp-hero-gradient border-t border-white/5">
      <p className="text-center text-white/50 text-xs uppercase tracking-widest pt-8">Trusted by businesses on our platform</p>
      <div className="gp-marquee-wrap overflow-hidden py-8">
        <div className="gp-marquee-track items-center gap-10 px-8">
          {row.map((b, i) => (
            <Link
              key={i}
              to={`/store/${b.slug}`}
              title={`Visit ${b.name}`}
              className="flex-shrink-0 flex items-center gap-2 opacity-80 hover:opacity-100 transition-opacity"
            >
              {b.logo_url ? (
                <img src={b.logo_url} alt={b.name} className="h-12 w-auto object-contain max-w-[150px]" />
              ) : (
                <span className="flex items-center gap-2 text-white font-medium text-lg whitespace-nowrap border border-white/15 rounded-full px-5 py-2">
                  <Store size={16} className="text-[#2ec9c9]" /> {b.name}
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
